import React from 'react';
import { UsergroupAddOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

interface IProps {
  tooltip?: string;
  onClick?: () => void;
  style?: React.CSSProperties | undefined;
  className?: string | undefined;
}

const UsergroupAddIcon = ({ tooltip, onClick, style, className }: IProps) => {
  return (
    <Tooltip title={tooltip}>
      <UsergroupAddOutlined
        onClick={onClick}
        style={{ color: '#52c41a', fontSize: 16, ...style }}
        className={className}
      />
    </Tooltip>
  );
};

export default UsergroupAddIcon;
